import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const put = (id,vacation) =>
  requestsTemplates.put(mainPath, `/vacations/${id}`,vacation);
